'use client';

import { FlagProvider } from '@unleash/nextjs/client';
import type { ChildrenProps } from 'viewup-lib/common';
import { type FlagBootstrap, UNLEASH_CONFIG } from './featureFlagConfig';

interface FeatureFlagProviderProps extends ChildrenProps {
  /** 서버에서 조회한 플래그. 있으면 SSR·hydration 첫 렌더부터 useFlag 가 이 값을 쓴다. */
  bootstrap?: FlagBootstrap;
}

export const FeatureFlagProvider = (props: FeatureFlagProviderProps) => {
  return (
    // bootstrap 키 자체를 빼야 한다 — `bootstrap: undefined` 가 아니라 키 부재일 때 기존 동작(ready 대기)과 같다.
    <FlagProvider
      config={{ ...UNLEASH_CONFIG, ...(props.bootstrap && { bootstrap: props.bootstrap }) }}
    >
      {props.children}
    </FlagProvider>
  );
};
